import { render, staticRenderFns } from "./contact1-footer.vue?vue&type=template&id=1c91e852&scoped=true&"
import script from "./contact1-footer.vue?vue&type=script&lang=js&"
export * from "./contact1-footer.vue?vue&type=script&lang=js&"
import style0 from "./contact1-footer.vue?vue&type=style&index=0&id=1c91e852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91e852",
  null
  
)

export default component.exports